var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buttontab-bd"},[_c('div',{staticClass:"ub"},_vm._l((_vm.list),function(item){return _c('div',{staticClass:"ub-f1",class:[{'cur': item === _vm.value},{'radius': _vm.type === 'radius'}],on:{"click":function($event){return _vm.onEmit(item)}}},[_vm._v(_vm._s(item)+"\n    ")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e7ba075","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttontab.vue
// module id = null
// module chunks = 